import Vue from 'vue'
import Vuex from 'vuex'// Vuex store，它是应用中集中管理状态的地方。
import { checkAuth } from '@/api/upfile'
Vue.use(Vuex)

//  Vuex store，它是应用中集中管理状态的地方。
export default new Vuex.Store({
  // 状态 (State) 这两个状态是判断用户是否登录的关键数据。
  state: {
    // token: 存储用户的认证令牌，从 localStorage 中获取初始值（如果有的话）
    token: localStorage.getItem('token') || null,
    // user: 存储用户信息，从 localStorage 中获取初始值并解析为对象
    user: JSON.parse(localStorage.getItem('user')) || null,
    // 新增：账户余额，默认为 0
    balance: 0.00
    // 注意：不从 localStorage 初始化 balance，因其易过期
  },
  // 变更 (Mutations) 在 Vuex 中，mutation 是唯一可以直接修改 state 的方法：
  mutations: {
    // setToken: 设置认证令牌，同时保存到 localStorage
    setToken (state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    // setUser: 设置用户信息，同时保存到 localStorage
    setUser (state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    // logout: 清除令牌和用户信息，同时从 localStorage 中移除
    logout (state) {
      state.token = null
      state.user = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      state.balance = 0.00 // 清除余额
    },
    // 新增：专门用于更新余额
    setBalance (state, balance) {
      // 确保是数字
      state.balance = typeof balance === 'number' ? balance : parseFloat(balance) || 0.00
    }
  },
  // Action 可以包含异步操作，通常用于业务逻辑
  actions: {
    // login: 提交 setToken 和 setUser 这两个 mutation 来保存登录信息
    async login ({ commit }, { token, user, balance }) {
      commit('setToken', token)
      commit('setUser', user)
      commit('setBalance', balance || 0.00) // 👈 登录时初始化余额
    },
    // logout: 提交 logout mutation 来清除登录信息
    async logout ({ commit }) {
      commit('logout')
    },
    // checkAuth: 检查 token 是否有效，如果无效则调用 logout
    async checkAuth ({ commit, state }) {
      if (!state.token) return false
      try {
        const response = await checkAuth(state.token)
        if (response.isValid) {
          return true
        } else {
          commit('logout')
          return false
        }
      } catch (error) {
        console.error('验证 token 时出错:', error)
        commit('logout')
        return false
      }
    }
  },
  // Getters 用于从 state 中派生出一些状态，类似于计算属性  Getter 类似于计算属性，用于派生状态：
  getters: {
    // isLoggedIn: 判断用户是否登录，基于 token 是否存在； isLoggedIn: 通过检查 token 是否存在来判断用户是否已登录
    isLoggedIn: state => !!state.token,
    // !! 运算符将 token 转换为布尔值（有 token 返回 true，无 token 返回 false）
    // 新增 getter：格式化后的余额（可用于显示）
    formattedBalance: state => `¥ ${parseFloat(state.balance).toFixed(2)}`,
    // 或者直接暴露原始余额
    balance: state => state.balance
  }
})
